import DashboardLayout from './DashboardLayout';
export default function LabAdminLayout() { return <DashboardLayout area="lab" />; }
